module.exports = __webpack_public_path__ + "img/maintenance-bg.6de432d0.jpg";